import { initRellax } from "./rellax.ts";
import { initAOS } from "./aos.ts";


export {
  initRellax,
  initAOS
}
